import * as React from "react";

import { PlpPresenterForTheFilterMenu_AnyBreakpointProvider } from "./plp-presenter-for-the-filter-menu-any-breakpoint-provider";
import { PlpPresenterForTheFilterMenu_DesktopProvider } from "./plp-presenter-for-the-filter-menu-desktop-provider";
import { PlpPresenterForTheFilterMenu_MobileProvider } from "./plp-presenter-for-the-filter-menu-mobile-provider";

export const PlpPresenterForTheFilterMenuProvider: React.FunctionComponent = (
  props
) => {
  return (
    <PlpPresenterForTheFilterMenu_AnyBreakpointProvider>
      <PlpPresenterForTheFilterMenu_MobileProvider>
        <PlpPresenterForTheFilterMenu_DesktopProvider>
          {props.children || []}
        </PlpPresenterForTheFilterMenu_DesktopProvider>
      </PlpPresenterForTheFilterMenu_MobileProvider>
    </PlpPresenterForTheFilterMenu_AnyBreakpointProvider>
  );
};
